import { Alert, CircularProgress, Modal, Snackbar, Box, FormControl, InputLabel } from "@mui/material";
import { useState } from "react";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import { style as modalStyle } from "../../../components/Loading/Loading";
import { WhiteInput } from "../../../components/Inputs/InputText";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller } from "react-hook-form";
import propStyles from "./AlterarSenha.module.css"; 
import { HelperText } from "../../../components/Errors/HelperText";
import servLogin from "../../../services/login/servLogin";
import { logout } from "../../../state/slices/userSlice";

const schema = yup.object().shape({
    SenhaAntiga: yup.string().required("Este campo é obrigatório"), 
    NovaSenha: yup.string().matches(
        /^.*(?=.{6,})(?=.*\d)((?=.*[aA-zZ]){1}).*$/,
        "A senha deve conter no mínimo 6 caracteres, contendo letras e números"
    ).required("Este campo é obrigatório"), 
    ConfirmarNovaSenha: yup.string().required("Este campo é obrigatório").oneOf([yup.ref('NovaSenha')], "As senhas não coincidem")
});

const AlterarSenha = ({ setOpenPopup  }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [openAlertWindow, setOpenAlertWindow] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [severity, setSeverity] = useState("info");

    const user = useSelector(state => state.user);
    const { register, control, handleSubmit, setValue, getValues, formState: { errors } } = useForm({ resolver: yupResolver(schema) });
    const dispatch = useDispatch();

    const handleCloseAlert = (event, reason) => {
        if (reason  === 'clickaway') {
            setOpenAlertWindow(false);
        }

        setOpenAlertWindow(false);
    }

    const onClickAlterarSenha = handleSubmit ( async () => {
        try {
            setIsLoading(true);

            let dto = {
                Email: user.email,
                SenhaAntiga: getValues("SenhaAntiga"),
                NovaSenha: getValues("NovaSenha")
            };
            
            await servLogin.alterarSenhaAtual(user.codigoUsuario, dto);
            
            setIsLoading(false);
            setSeverity("success");
            setAlertMessage("Senha atualizada com sucesso");
            setOpenAlertWindow(true);

            setTimeout(() => {
                setOpenPopup(false);
                dispatch(logout());
            }, [1300]);
        } catch (err) {
            setIsLoading(false);
            setSeverity("error");
            setAlertMessage(err?.response?.data?.Message);
            return setOpenAlertWindow(true);
        }
    })

    return (
        <div style={{ width: "100%", minWidth: "730px", maxWidth: "730px", height: "20%" }}>
            <h4>
                Informe com atenção a nova senha desejada nos campos abaixo.<br />
                Após a confirmação de atualização da senha, você deverá realizar login novamente.
            </h4>
            <div onSubmit={onClickAlterarSenha}> 
                <Controller
                    name="SenhaAntiga"
                    control={control}
                    render={({field}) => (
                        <FormControl variant="outlined" style={{ margin: '20px 0px 10px 35px', width: '90%' }}>
                            <InputLabel htmlFor="login-senhaatual" shrink style={{ color: "#B8B8B8" }} >
                                Senha atual
                            </InputLabel>
                            <WhiteInput 
                                fullWidth
                                placeholder="Senha atual" 
                                type="password"
                                id="login-senhaatual" 
                                error={!!errors.SenhaAntiga}
                                {...field}
                                className={`${errors?.SenhaAntiga ? propStyles.campoComValorErrado : ""}`}
                            />
                            { errors?.SenhaAntiga ?  (
                                <HelperText text={errors?.SenhaAntiga?.message} />
                            ) : '' }
                        </FormControl>
                    )}
                />

                <Controller
                    name="NovaSenha"
                    control={control}
                    render={({field}) => (
                        <FormControl variant="outlined" style={{ margin: '20px 0px 10px 35px', width: '90%' }}>
                            <InputLabel htmlFor="login-novasenha" shrink style={{ color: "#B8B8B8" }} >
                                Nova senha
                            </InputLabel>
                            <WhiteInput 
                                fullWidth
                                placeholder="Nova senha" 
                                type="password"
                                id="login-novasenha" 
                                error={!!errors.NovaSenha}
                                {...field}
                                className={`${errors?.NovaSenha ? propStyles.campoComValorErrado : ""}`}
                            />
                            { errors?.NovaSenha ?  (
                                <HelperText text={errors?.NovaSenha?.message} />
                            ) : '' }
                        </FormControl>
                    )}
                />

                <Controller
                    name="ConfirmarNovaSenha"
                    control={control}
                    render={({field}) => (
                        <FormControl variant="outlined" style={{ margin: '20px 0px 10px 35px', width: '90%' }}>
                            <InputLabel htmlFor="login-confirmarnovasenha" shrink style={{ color: "#B8B8B8" }} >
                                Confirmar nova senha
                            </InputLabel>
                            <WhiteInput 
                                fullWidth
                                placeholder="Confirmar nova senha" 
                                type="password"
                                id="login-confirmarnovasenha" 
                                error={!!errors.ConfirmarNovaSenha}
                                {...field}
                                className={`${errors?.ConfirmarNovaSenha ? propStyles.campoComValorErrado : ""}`}
                            />
                            { errors?.ConfirmarNovaSenha ?  (
                                <HelperText text={errors?.ConfirmarNovaSenha?.message} />
                            ) : '' }
                        </FormControl>
                    )}
                />
            </div>
            <div style={{
                padding: "10px 45px",
                display: "flex",
                justifyContent: "flex-end",
                gap: "20px"
            }}>
                <BlueHoverButton onClick={onClickAlterarSenha}>Alterar senha</BlueHoverButton>
            </div>

            <Snackbar open={openAlertWindow} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseAlert}> 
                    <Alert onClose={handleCloseAlert} severity={severity} sx={{ width: '100%' }}>
                        {alertMessage}
                    </Alert>
            </Snackbar>

            <Modal open={isLoading}>
                <Box style={modalStyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
        </div>
    )
}

export { AlterarSenha };